<div class="tramite-componente">
  <p>Trámites</p>

  <div
    *ngIf="
      aDatos != null && aDatos != undefined && aDatos.length > 0;
      then tramites;
      else sintramites
    "
  ></div>

  <ng-template #tramites>
    <mat-accordion #acordeon="matAccordion">
      <mat-expansion-panel
        *ngFor="let oTramite of aDatos; let i = index"
        (opened)="panelOpenState = true"
        style="box-shadow: none; font-size: 0.9em"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="tramite-area-titulo">
            {{ oTramite.TRAMITE }}
          </mat-panel-title>
          <mat-panel-description> </mat-panel-description>
        </mat-expansion-panel-header>
        <p
          *ngIf="oTramite.INFO_TRAMITE !== ''"
          [innerHTML]="oTramite.INFO_TRAMITE"
        ></p>
        <div class="mensaje">
          <p>Documentación a aportar:</p>
          <div class="caja-info2">
            <ul>
              <li
                class="caja-info-area"
                *ngFor="let oDocumento of oTramite.DOCUMENTOS"
                [innerHTML]="oDocumento.INFO()"
              ></li>
            </ul>
          </div>
        </div>
        <br />
        <div class="btn-grupo">
          <button (click)="PedirCita(oTramite)" class="btn-general">
            <span>Solicitar Cita</span>
          </button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-template>

  <ng-template #sintramites>
    <p style="text-align: center">No hay trámites definidos</p>
  </ng-template>
</div>
